import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMemo } from "react";
import Alert from "@mui/material/Alert";
import AlertTitle from "@mui/material/AlertTitle";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import { PromiseView } from "./PromiseView";
import { SimpleDialog } from "./SimpleDialog";
/**
 * Display fetch error
 * @param props
 * @returns
 */
export function FetchErrorView(props) {
    const { response } = props;
    const json = useMemo(() => {
        return response
            .clone()
            .json()
            .catch((err) => ({ error: err.toString() }));
    }, [response]);
    const text = useMemo(() => {
        return response
            .clone()
            .text()
            .catch(() => "");
    }, [response]);
    return (_jsxs(Alert, { severity: "error", children: [_jsx(AlertTitle, { children: response.statusText }), _jsxs(Typography, { children: ["Request failed with ", response.status] }), _jsx(Tooltip, { title: _jsx("code", { children: response.url }), children: _jsx(Button, { color: "error", children: "URL" }) }), _jsx(SimpleDialog, { title: "JSON", color: "error", content: _jsx(PromiseView, { data: json }) }), _jsx(SimpleDialog, { title: "Text", color: "error", content: _jsx(PromiseView, { data: text }) })] }));
}
//# sourceMappingURL=FetchErrorView.js.map